import { css } from '@emotion/react';
import React from 'react';

import { langDirClassname } from '$/shared/frontend/utils/i18n';

import type { InteractionInfo } from '../InteractionInfo';

export const KofiFrame: React.FC<{
  interaction: InteractionInfo;
  username: string;
  className?: string;
}> = ({ interaction, username, className }) => {
  const dir = langDirClassname(interaction.ewebinar?.viewerRoomSettings.language);
  return (
    <iframe
      id={`kofi-card-${interaction.id || 'new'}`}
      src={`https://ko-fi.com/${username}/?hidefeed=true&widget=true&embed=true&preview=true`}
      title={username}
      className={className}
      css={[
        css`
          border-radius: 2rem;
          transform: scale(0.84);
          width: 119%;
          transform-origin: ${dir === 'rtl' ? 'right top' : 'left top'};
          height: 710px;
          overflow: hidden;
        `,
      ]}
    />
  );
};
